import {catchError, Observable, switchMap, throwError} from 'rxjs';
import {HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {inject} from '@angular/core';
import {AuthenticationService} from '../../services/authentication/authentication.service';

export function authenticationInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const authenticationService = inject(AuthenticationService);

  if (req.url.includes('/login_check') || req.url.includes('/token/refresh')) {
    return next(req);
  }

  const tokens = authenticationService.getTokens();

  if (tokens) {
    const clonedReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${tokens.token}`)
    });

    return next(clonedReq).pipe(
      catchError(err => {

        if (err.status === 401) {

          return authenticationService.refreshToken().pipe(
            switchMap(newTokens => {
              const newReq = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${newTokens.token}`)
              });

              return next(newReq);
            }),
            catchError(refreshError => {
              authenticationService.logout();
              return throwError(() => refreshError);
            })
          );
        }

        return throwError(() => err);
      })
    );
  }

  return next(req);
}
